import React from "react";


export type ObsChartCtxValue = {
  value: {
    isActive: boolean;
  },
  set: (v: ObsChartCtxValue[ "value" ]) => unknown,
}
export const defaultObsChartCtxValue: ObsChartCtxValue = {
  value: { isActive: false },
  set: console.log
};

export const ObsChartCtx = React.createContext(defaultObsChartCtxValue);
export const useObsChartCtx = () => React.useContext(ObsChartCtx);

export const WithObsChartCtx: React.FC< React.PropsWithChildren > = React.memo(p => {
  const [value, set] = React.useState(defaultObsChartCtxValue.value);
  const ctxValue = React.useMemo(() => ({value, set}), [value, set]);

  return (
    <ObsChartCtx.Provider value={ ctxValue }>
      { p.children }
    </ObsChartCtx.Provider>
  );
});
WithObsChartCtx.displayName = "components/ObservatioChart/WithObsChartCtx";
